var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12532_313985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 14.5H10.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.91883 10.439C4.32443 9.97464 3.84299 9.38165 3.51067 8.70455C3.17834 8.02745 3.00377 7.28384 3.00008 6.52959C2.98508 3.81959 5.17008 1.56397 7.87945 1.50147C8.92946 1.47603 9.96081 1.7819 10.8272 2.37568C11.6935 2.96945 12.3509 3.82098 12.7061 4.80944C13.0612 5.79789 13.096 6.87308 12.8056 7.88245C12.5152 8.89182 11.9143 9.78411 11.0882 10.4327C10.906 10.574 10.7583 10.7549 10.6564 10.9617C10.5545 11.1686 10.5011 11.3959 10.5001 11.6265V12.0015C10.5001 12.1341 10.4474 12.2613 10.3536 12.355C10.2599 12.4488 10.1327 12.5015 10.0001 12.5015H6.00008C5.86747 12.5015 5.74029 12.4488 5.64652 12.355C5.55276 12.2613 5.50008 12.1341 5.50008 12.0015V11.6265C5.49984 11.3974 5.44736 11.1713 5.34664 10.9656C5.24592 10.7598 5.09961 10.5797 4.91883 10.439Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 3.5C9.75 3.71062 10.7881 4.75 11 6",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12532_313985"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIcon);
export default __webpack_public_path__ + "static/media/faq-icon.5e7004bb569a68e3b691c535d0de3c11.svg";
export { ForwardRef as ReactComponent };